export default class BarSeries {
    constructor(attributes) {
        this.key = attributes.key
        this.xAxis = attributes.x_axis
        this.yAxis = attributes.y_axis
        this.xKey = attributes.x_key
        this.yKey = attributes.y_key
        this.options = attributes.bar_options
        this.data = attributes.data
    }

    matchesAxes(xAxisLabel, yAxisLabel) {
        return this.xAxis === xAxisLabel && this.yAxis === yAxisLabel
    }
}
